<template>
	<div class="row">
		<div class="col-md-12">
			<section class="panel">
				<header class="panel-heading">
					<h2 class="panel-title">設定開放時間</h2>
				</header>
				<div class="panel-body container-fluid">
					<div class="row form-group" v-for="(item, index) in roomTimeSettingList" :key="index">
						<div class="col-md-2 col-sm-2 col-xs-12 form-group">
							<label>{{settingTitle(item.commCode)}}</label>
						</div>
						<div v-if="item.commCode == 'APPLY_YM'">
							<div class="col-md-5 col-sm-5 col-xs-12 form-group" >
								<label>開放學年&nbsp;&nbsp;</label>
								<select v-model="applyY">
									<option value="">--請選擇--</option>
									<option v-for="(key,index) in yearList" :key="index" :value="key">{{key}}學年</option>
								</select>
							</div>
							<div class="col-md-5 col-sm-5 col-xs-12 form-group" >
								<label>開放學期&nbsp;&nbsp;</label>
								<select v-model="applyM">
									<option value="">--請選擇--</option>
									<option value="1">第一學期</option>
									<option value="2">第二學期</option>
								</select>
							</div>
						</div>
						<div v-else-if="item.commCode == 'PAY'">
							<div class="col-md-5 col-sm-5 col-xs-12 form-group">
								<label>繳費截止日&nbsp;&nbsp;</label>
								<datepicker :format="customFormatter" :language="zh" input-class="form-control" v-model="item.commValue" name="beginDate" :style="{width:'auto', display:'inline-block'}">
								</datepicker>
								<span class="text-danger" v-show="errors.has('beginDate')">{{ errors.first('beginDate') }}</span>
							</div>
						</div>
						<div v-else>
							<div class="col-md-5 col-sm-5 col-xs-12 form-group">
								<label>開放日&emsp;&emsp;&nbsp;&nbsp;</label>
								<datepicker :format="customFormatter" :language="zh" input-class="form-control" v-model="item.commValue" name="beginDate" :style="{width:'auto', display:'inline-block'}">
								</datepicker>
								<span class="text-danger" v-show="errors.has('beginDate')">{{ errors.first('beginDate') }}</span>
							</div>
							<div class="col-md-5 col-sm-5 col-xs-12 form-group" >
								<label>結束日&emsp;&emsp;&nbsp;&nbsp;</label>
								<datepicker :format="customFormatter" :language="zh" input-class="form-control" v-model="item.commValue2" name="endDate" :style="{width:'auto', display:'inline-block'}">
								</datepicker>
								<span class="text-danger" v-show="errors.has('endDate')">{{ errors.first('endDate') }}</span>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12">
							<div class="col-md-2 "></div>
							<div class="col-md-2 col-xs-3"></div>
							<div class="col-md-2 col-xs-3">
								<button @click="handleCancel" class="btn btn-default btn-block">取消</button>
							</div>
							<div class="col-md-2 col-xs-3">
								<button @click="handleSave" class="btn btn-primary btn-block">儲存</button>
							</div>
							<div class="col-md-2 col-xs-3"></div>
							<div class="col-md-2 "></div>
						</div>
					</div>
				</div>
				
			</section>

			<!-- QRCODE 設定區塊 -->
			<section class="panel">
				<header class="panel-heading">
					<h2 class="panel-title">設定 QRCODE</h2>
				</header>
				<div class="panel-body container-fluid">
					<div class="row form-group">
						<div class="col-md-2 col-sm-2 col-xs-12 form-group">
							<label>學年度 / 學期:</label>
						</div>
						<div class="col-md-8 col-sm-8 col-xs-12 form-group">
							<input type="text" class="form-control" v-model="qrcode.applyYearSemester" placeholder="例如：1142" style="display:inline-block; width:auto;" />
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-2 col-sm-2 col-xs-12 form-group">
							<label>開放期間:</label>
						</div>
						<div class="col-md-4 col-sm-4 col-xs-12 form-group">
							<label>開始日期時間&nbsp;&nbsp;</label>
							<datepicker :format="customFormatter" :language="zh" input-class="form-control" v-model="qrcode.beginDate" name="qrcodeBeginDate" :style="{width:'auto', display:'inline-block'}">
							</datepicker>
							<input type="time" class="form-control" v-model="qrcode.beginTime" style="display:inline-block; width:auto; margin-top:5px;" />
						</div>
						<div class="col-md-4 col-sm-4 col-xs-12 form-group">
							<label>結束日期時間&nbsp;&nbsp;</label>
							<datepicker :format="customFormatter" :language="zh" input-class="form-control" v-model="qrcode.endDate" name="qrcodeEndDate" :style="{width:'auto', display:'inline-block'}">
							</datepicker>
							<input type="time" class="form-control" v-model="qrcode.endTime" style="display:inline-block; width:auto; margin-top:5px;" />
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-2 col-sm-2 col-xs-12 form-group">
							<label>選擇寒暑假:</label>
						</div>
						<div class="col-md-4 col-sm-4 col-xs-12 form-group">
							<select class="form-control" v-model="qrcode.vacationType" style="width:auto; display:inline-block;">
								<option value="">--請選擇--</option>
								<option value="winter">寒假</option>
								<option value="summer">暑假</option>
							</select>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-2 col-sm-2 col-xs-12 form-group">
							<label>選擇入宿 / 離宿:</label>
						</div>
						<div class="col-md-4 col-sm-4 col-xs-12 form-group">
							<select class="form-control" v-model="qrcode.stayType" style="width:auto; display:inline-block;">
								<option value="">--請選擇--</option>
								<option value="checkin">入宿</option>
								<option value="checkout">離宿</option>
							</select>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12">
							<div class="col-md-2"></div>
							<div class="col-md-2 col-xs-3"></div>
							<div class="col-md-2 col-xs-3">
								<button @click="handleCancel" class="btn btn-default btn-block">取消</button>
							</div>
							<div class="col-md-2 col-xs-3">
								<button @click="handleQrcodeSave" class="btn btn-primary btn-block">儲存</button>
							</div>
							<div class="col-md-2 col-xs-3"></div>
							<div class="col-md-2"></div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import moment from "moment";
export default {
	data() {
		return {
			settintList:[],
			roomTimeSettingList: [],
			applyY:"",
			applyM:"",
			qrcode: {
				applyYearSemester: "",
				beginDate: "",
				beginTime: "",
				endDate: "",
				endTime: "",
				vacationType: "",
				stayType: "",
			},
		}
	},
	created() {
		const api = "/api/Common/roomTimeSetting/"
		this.$axios.post(api).then(resp => {
			this.roomTimeSettingList = resp.data.data.roomTimeSettingList
			let applyYm = this.roomTimeSettingList.filter(item =>{
				return item.commCode == "APPLY_YM";
			});
			if(applyYm.length > 0){
				this.applyY = applyYm[0].commValue;
				this.applyM = applyYm[0].commValue2;
			}
		});
		// 載入 QRCODE 設定
		this.$axios.post("/api/Common/qrcodeSetting").then(resp => {
			const list = resp.data.data.qrcodeSettingList;
			if(list && list.length > 0){
				let applyYm = list.find(item => item.commCode == "APPLY_YM");
				let period = list.find(item => item.commCode == "PERIOD");
				let vacation = list.find(item => item.commCode == "VACATION");
				let stayType = list.find(item => item.commCode == "STAY_TYPE");
				if(applyYm) this.qrcode.applyYearSemester = applyYm.commValue || "";
				if(period){
					if(period.commValue){
						let parts = period.commValue.split(" ");
						this.qrcode.beginDate = parts[0] ? this.dateFormatter(parts[0]) : "";
						this.qrcode.beginTime = parts[1] || "";
					}
					if(period.commValue2){
						let parts2 = period.commValue2.split(" ");
						this.qrcode.endDate = parts2[0] ? this.dateFormatter(parts2[0]) : "";
						this.qrcode.endTime = parts2[1] || "";
					}
				}
				if(vacation) this.qrcode.vacationType = vacation.commValue || "";
				if(stayType) this.qrcode.stayType = stayType.commValue || "";
			}
		});
	},
	updated() {
	},
	methods: {
		handleCancel() {
			this.$router.go(-1)
		},
		handleQrcodeSave() {
			if (!this.qrcode.applyYearSemester) {
				bootbox.alert("請填寫學年度/學期");
				return;
			}
			if (!this.qrcode.beginDate || !this.qrcode.beginTime || !this.qrcode.endDate || !this.qrcode.endTime) {
				bootbox.alert("請選擇完整的開放期間（日期與時間）");
				return;
			}
			if (!this.qrcode.stayType) {
				bootbox.alert("請選擇入宿或離宿");
				return;
			}
			const payload = [
				{
					commType: "QRCODE",
					commCode: "APPLY_YM",
					commValue: this.qrcode.applyYearSemester,
					commValue2: "",
				},
				{
					commType: "QRCODE",
					commCode: "PERIOD",
					commValue: this.customFormatter(this.qrcode.beginDate) + " " + this.qrcode.beginTime,
					commValue2: this.customFormatter(this.qrcode.endDate) + " " + this.qrcode.endTime,
				},
				{
					commType: "QRCODE",
					commCode: "VACATION",
					commValue: this.qrcode.vacationType,
					commValue2: "",
				},
				{
					commType: "QRCODE",
					commCode: "STAY_TYPE",
					commValue: this.qrcode.stayType,
					commValue2: "",
				},
			];
			const api = "/api/Common/saveQrcodeSetting";
			this.$axios.post(api, payload).then(resp => {
				if (resp.data.status === "success") {
					bootbox.alert("QRCODE 設定儲存成功");
				} else {
					bootbox.alert(resp.data.msg);
				}
			});
		},
		handleSave() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.roomTimeSettingList.forEach(item =>{
						// console.log(item);
						if(item.commCode == "APPLY_YM"){
							item.commValue = this.applyY;
							item.commValue2 = this.applyM;
						}else{
							item.commValue = this.customFormatter(item.commValue);
							if(item.commCode != "PAY"){
								item.commValue2 = this.customFormatter(item.commValue2);
							}
						}
					});
					const api = "/api/Common/saveRoomTimeSetting";
					this.$axios.post(api, this.roomTimeSettingList ).then(resp => {
						if (resp.data.status === "success") {
							if (this.applyType === 'N' && this.editStatus === 'N') {
								this.$router.push({ name: 'index' })
							} else {
								this.$router.push({ name: 'stay.list' })
							}
						} else {
							bootbox.alert(resp.data.msg)
						}
					});
				} else {
					bootbox.alert("請確認必填欄位是否有填寫")
				}
			});

		},
		settingTitle(commCode){
			let str = "";
			if(commCode == "N"){
				str = "一般申請住宿: ";
			}else if(commCode == "V"){
				str = "寒暑假申請住宿: ";
			}else if(commCode == "L"){
				str = "離宿申請住宿: ";
			}else if(commCode == "PAY"){
				str = "繳費期限: ";
			}else if(commCode == "APPLY_YM"){
				str = "住宿申請學年期: ";
			}
			return str;
		}
	},
	computed:{
		yearList(){
			let years = [];
			for(let i=(new Date().getUTCFullYear() -1911); i >= 109; i--){
				years.push(i.toString());
			}
			return years;
		}
	}
}
</script>

<style scoped>
</style>
